/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";

/* PACKAGES */
import moment from "moment";
import { toast } from "sonner";
import DataTable from "react-data-table-component";

/* MATERIAL TAILWIND COMPONENTS */
import {
  Card,
  CardBody,
  Button,
  Dialog,
  DialogBody,
} from "@material-tailwind/react";

/* APIS */
import { deleteContactUs, getContactUs } from "service/api";

/* ICONS */
import { IoEye, IoClose } from "react-icons/io5";
import { IoMdTrash } from "react-icons/io";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const ContactUs = () => {
  /* STATES */
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [fetchData, setFetchedData] = useState([]);
  const [totalDocs, setTotalDocs] = useState(0);

  /* MODAL */
  const [viewData, setViewData] = useState();
  const [viewModal, setViewModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteID, setDeleteID] = useState(null);

  const { token } = useSelector((state) => state.user);
  const navigate = useNavigate();

  if (token === null) {
    navigate("/");
  }

  const handleDelete = () => {
    deleteContactUs(deleteID)
      .then((res) => {
        getContactUsData();
        toast.success(res?.message);
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      })
      .finally((res) => {
        setDeleteModal(!deleteModal);
      });
  };

  const handlePerPageChange = async (e) => {
    setSizePerPage(e);
  };
  const handlePageChange = async (e) => {
    setPage(e);
  };

  /* GET CONTACT US DATA */
  const getContactUsData = () => {
    let params;
    params = {
      page: page,
      sizePerPage: sizePerPage,
      pagination: false,
    };
    setLoading(true);
    getContactUs(params)
      .then((res) => {
        setFetchedData(res?.data);
        console.log(res);
        setTotalDocs(res?.data?.length);
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error While Fetching Contact Us  List", error);
      });
  };

  /* COLUMNS */
  const columns = [
    {
      name: "Name",
      selector: (row) => (
        <>
          <p className="text-sm font-source font-medium text-black">
            {row?.name}
          </p>
        </>
      ),
    },
    {
      name: "Email and Phone",
      grow: 1.5,
      selector: (row) => (
        <>
          <a
            href={`mailto:${row.email}`}
            className="block text-sm font-source font-normal underline text-blue-400"
          >
            {row.email}
          </a>
          <a
            href={`tel:${row.phoneNumber}`}
            className="mt-1 block text-sm font-source font-normal underline text-blue-400"
          >
            {row.phoneNumber}
          </a>
        </>
      ),
    },
    {
      name: "Message",
      grow: 2,
      selector: (row) => (
        <p className="text-sm font-source font-normal text-greyText line-clamp-2">
          {row.message}
        </p>
      ),
    },
    {
      name: "Date",
      grow: 0.5,
      selector: (row) => (
        <p className="text-sm font-source font-normal text-greyText">
          {moment(row?.createdAt).format("MMM, DD YYYY")}
        </p>
      ),
    },
    {
      name: "Actions",
      grow: 0.5,
      selector: (row) => (
        <div className="flex items-center gap-2">
          <Button
            onClick={() => {
              setViewModal(!viewModal);
              setViewData(row);
            }}
            className="shadow-none hover:shadow-none p-1.5 bg-transparent hover:bg-black hover:bg-opacity-10 rounded-full transition-all duration-300 ease-in-out"
          >
            <IoEye className="w-4 h-4 text-greyText" />
          </Button>
          <Button
            onClick={() => {
              setDeleteModal(!deleteModal);
              setDeleteID(row?._id);
            }}
            className="shadow-none hover:shadow-none p-1.5 bg-transparent hover:bg-black hover:bg-opacity-10 rounded-full transition-all duration-300 ease-in-out"
          >
            <IoMdTrash className="w-4 h-4 text-greyText" />
          </Button>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getContactUsData();
  }, [page, sizePerPage]);

  return (
    <section className="p-0 relative">
      <div className="container">
        {/* HEADING */}
        <div className="py-10">
          <h5 className="text-3xl font-source font-bold text-white">
            Contact us Leads
          </h5>
          <p className="text-base font-source font-normal text-white/70">
            The queries received from the contact us page of your website
          </p>
        </div>

        {/* DATA TABLE */}
        <div className="pb-10">
          <Card className="bg-white border border-greyBorder shadow rounded-md">
            <CardBody className="p-0">
              <DataTable
                columns={columns}
                data={totalDocs > 0 ? fetchData : []}
                progressPending={loading}
                responsive
                progressComponent={
                  <div className="py-10 w-full rounded-md">
                    <p className="text-center font-source font-medium text-sm text-black">
                      Please wait while we are loading the data...
                    </p>
                  </div>
                }
                className="datatable"
                noDataComponent={
                  <div className="py-10 w-full rounded-md">
                    <p className="text-center font-source font-medium text-sm text-black">
                      There are no queries received from your website.
                    </p>
                  </div>
                }
                pagination
                paginationServer
                paginationTotalRows={totalDocs}
                onChangeRowsPerPage={handlePerPageChange}
                onChangePage={handlePageChange}
              />
            </CardBody>
          </Card>
        </div>
      </div>

      {/* BACKGROUND */}
      <div className="absolute top-0 left-0 w-full -z-10">
        <div className="w-full h-[25vh] bg-black" />
      </div>

      {/* VIEW MODAL */}
      <Dialog
        open={viewModal}
        handler={() => setViewModal(!viewModal)}
        size="sm"
      >
        <DialogBody className="p-0">
          {/* HEADING */}
          <div className="px-5 py-3 border-b border-greyBorder">
            <div className="flex items-center justify-between">
              <h5 className="text-sm font-source font-medium text-black">
                Query Details
              </h5>
              <Button
                onClick={() => setViewModal(!viewModal)}
                className="shadow-none p-1.5 hover:shadow-none bg-transparent hover:bg-black hover:bg-opacity-10 rounded-full transition-all duration-300 ease-in-out"
              >
                <IoClose className="w-4 h-4 text-greyText" />
              </Button>
            </div>
          </div>

          {/* BODY */}
          <div className="p-5 max-h-[40vh] overflow-auto">
            <p className="text-sm font-source font-normal text-greyText">
              <span className="text-black font-medium">Name:</span>{" "}
              {viewData?.name}
            </p>
            <p className="mt-1 text-sm font-source font-normal text-greyText">
              <span className="text-black font-medium">Email address:</span>{" "}
              {viewData?.email}
            </p>
            <p className="mt-1 text-sm font-source font-normal text-greyText">
              <span className="text-black font-medium">Phone:</span>{" "}
              {viewData?.phoneNumber}
            </p>
            <p className="mt-1 text-sm font-source font-normal text-greyText">
              <span className="text-black font-medium">Message:</span>{" "}
              {viewData?.message}
            </p>
          </div>
        </DialogBody>
      </Dialog>

      {/* DELETE MODAL */}
      <Dialog
        open={deleteModal}
        handler={() => setDeleteModal(!deleteModal)}
        size="xs"
      >
        <DialogBody className="p-0">
          {/* HEADING */}
          <div className="px-5 py-3 border-b border-greyBorder">
            <div className="flex items-center justify-between">
              <h5 className="text-sm font-source font-medium text-black">
                Confirmation
              </h5>
              <Button
                onClick={() => setDeleteModal(!deleteModal)}
                className="shadow-none p-1.5 hover:shadow-none bg-transparent hover:bg-black hover:bg-opacity-10 rounded-full transition-all duration-300 ease-in-out"
              >
                <IoClose className="w-4 h-4 text-greyText" />
              </Button>
            </div>
          </div>

          {/* BODY */}
          <div className="p-5">
            <p className="text-sm font-source font-normal text-greyText">
              Are you sure you want to delete this query?
            </p>
          </div>

          {/* FOOTER */}
          <div className="px-5 py-3 border-t border-greyBorder flex items-center justify-end">
            <Button
              onClick={handleDelete}
              className="px-5 py-2 shadow-none hover:shadow-none bg-primary hover:bg-opacity-70 transition-all duration-300 ease-in-out rounded-md text-sm font-source font-normal text-white normal-case"
            >
              Confirm
            </Button>
          </div>
        </DialogBody>
      </Dialog>
    </section>
  );
};

export default ContactUs;
